import * as _ from "lodash-es";
import * as qs from "query-string";
import React, { Component } from "react";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import INotification from "../../../../../models/INotification";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import SortOrderEnum from "../../../../../models/SortOrderEnum";
import SupplierService from "../../../../../services/SupplierService";
import OwButton from "../../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../../shared/OwInputWrapper/OwInputWrapper";
import { Socket } from "socket.io-client";
import { OwFnInput } from "../../../../shared/OwFnInput/OwFnInput";

type Props = {
    searchActive: boolean;
    searchFn: (queryString: string, searchResults: any, reset: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    sortDir: SortOrderEnum;
    sortCol: string;
    location: any;
    history: any;
};

type State = {
    name?: string;
};

class SupplierUserFilter extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            name: this.parseUrlForFilter(),
        };
    }

    componentDidMount() {
        if (this.state.name) {
            this.performSearch();
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (prevProps.sortDir !== this.props.sortDir || prevProps.sortCol !== this.props.sortCol) {
            this.performSearch();
        }
    }

    componentWillUnmount(): void {}

    performSearch = () => {
        const query: string[] = [];
        let queryString = "";

        const props = [{ state: "name", subProp: "" }];

        for (const prop of props) {
            // @ts-expect-error
            if (!_.isNil(this.state[prop.state])) {
                const name = prop.state;
                // @ts-expect-error
                const encodedValue = encodeURIComponent(this.state[name]);
                // @ts-expect-error
                query.push(`${name}=${encodedValue}`);
            }
        }

        if (!_.isNil(this.props.sortCol)) {
            query.push(`order_by=${this.props.sortCol}`);
        }

        if (!_.isNil(this.props.sortDir)) {
            query.push(`order_dir=${this.props.sortDir}`);
        }

        if (query.length) {
            queryString = "?";

            queryString += query.join("&");
        }

        let url = `/users`;

        url = SupplierService.updateStringWithVendorOverride(url, this.props.supplierModel);

        this.props.history(`${url}${queryString}`);

        this.props.searchFn(queryString, [], false);
    };

    resetSearch = () => {
        const state: any = {
            name: "",
        };

        let url = `/users`;

        url = SupplierService.updateStringWithVendorOverride(url, this.props.supplierModel);

        this.props.history(`${url}`);

        this.setState(state, () => {
            const reset = true;
            const searchResults = false;

            this.props.searchFn("", [], reset);
        });
    };

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        console.log("e.charCode", e.charCode);

        if (e.key === "Enter") {
            this.performSearch();
        } else {
            const state: any = {
                [name]: value,
            };

            this.setState(state);
        }
    };

    parseUrlForFilter = (): string | undefined => {
        const parsedSearch = qs.parse(this.props.location.search);

        const name = _.get(parsedSearch, "name", undefined);

        if (name && _.isString(name)) {
            return name;
        } else {
            return undefined;
        }
    };

    render() {
        return (
            <div className={"SupplierUserFilter"}>
                <div className="row">
                    <div className={"col-12 col-sm-8 col-md-3"}>
                        <div className="position-relative">
                            <OwFnInput
                                className={"form-control-sm"}
                                fn={this.handleChange}
                                placeholder={"name_email"}
                                name={"name"}
                                value={this.state.name}
                            />
                        </div>
                    </div>
                    <div className={"col-12 col-sm-4 col-md-3"}>
                        <label className={"d-none"}>&nbsp;</label>
                        <div className="">
                            <OwButton title={"search"} fn={this.performSearch} active={this.props.searchActive} disableOnActive={true} />
                            <OwButton
                                title={"reset"}
                                fn={this.resetSearch}
                                className={"btn-danger ms-2"}
                                active={this.props.searchActive}
                                disableOnActive={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SupplierUserFilter;
